// extracted by mini-css-extract-plugin
module.exports = {"readMoreButton":"fYZZrz9o"};